import Quill from 'quill';
import { type BlockBlot } from 'parchment';
import { type BlotConstructorWithNodeType } from '../../extendedQuillTypes';

const Header = Quill.import('formats/header') as BlotConstructorWithNodeType<
	HTMLHeadingElement,
	BlockBlot
>;

const HEADER_ATTRIBUTES = ['class'];

const addAttributes = (headerAttributes, node) => {
	Object.keys(headerAttributes).map((key) => node.setAttribute(key, headerAttributes[key]));
	return node;
};

const getAttributes = (domNode) => {
	return HEADER_ATTRIBUTES.reduce(function (formats, attribute) {
		if (domNode.hasAttribute(attribute)) {
			formats[attribute] = domNode.getAttribute(attribute);
		}
		return formats;
	}, {});
};

class CustomH1 extends Header {
	static create(value) {
		const { headerIndex, headerAttributes } = value;
		const node = super.create(headerIndex);
		return headerAttributes ? addAttributes(headerAttributes, node) : node;
	}

	static formats(domNode) {
		const headerIndex = this.tagName.indexOf(domNode.tagName) + 1;
		return { headerIndex, headerAttributes: getAttributes(domNode) };
	}
}
CustomH1.blotName = 'h1';
CustomH1.tagName = 'h1';

class CustomH2 extends Header {
	static create(value) {
		const { headerIndex, headerAttributes } = value;
		const node = super.create(headerIndex);
		return headerAttributes ? addAttributes(headerAttributes, node) : node;
	}

	static formats(domNode) {
		const headerIndex = this.tagName.indexOf(domNode.tagName) + 1;
		return { headerIndex, headerAttributes: getAttributes(domNode) };
	}
}
CustomH2.blotName = 'h2';
CustomH2.tagName = 'h2';

class CustomH3 extends Header {
	static create(value) {
		const { headerIndex, headerAttributes } = value;
		const node = super.create(headerIndex);
		return headerAttributes ? addAttributes(headerAttributes, node) : node;
	}

	static formats(domNode) {
		const headerIndex = this.tagName.indexOf(domNode.tagName) + 1;
		return { headerIndex, headerAttributes: getAttributes(domNode) };
	}
}
CustomH3.blotName = 'h3';
CustomH3.tagName = 'h3';

class CustomH4 extends Header {
	static create(value) {
		const { headerIndex, headerAttributes } = value;
		const node = super.create(headerIndex);
		return headerAttributes ? addAttributes(headerAttributes, node) : node;
	}

	static formats(domNode) {
		const headerIndex = this.tagName.indexOf(domNode.tagName) + 1;
		return { headerIndex, headerAttributes: getAttributes(domNode) };
	}
}
CustomH4.blotName = 'h4';
CustomH4.tagName = 'h4';

class CustomH5 extends Header {
	static create(value) {
		const { headerIndex, headerAttributes } = value;
		const node = super.create(headerIndex);
		return headerAttributes ? addAttributes(headerAttributes, node) : node;
	}

	static formats(domNode) {
		const headerIndex = this.tagName.indexOf(domNode.tagName) + 1;
		return { headerIndex, headerAttributes: getAttributes(domNode) };
	}
}
CustomH5.blotName = 'h5';
CustomH5.tagName = 'h5';

class EyebrowHeading extends Header {
	static create() {
		const node = super.create();
		node.classList.add('eyebrow-heading');
		return node;
	}
}
EyebrowHeading.blotName = 'eyebrowHeading';
EyebrowHeading.tagName = 'h2';
EyebrowHeading.className = 'eyebrow-heading';

export { CustomH1, CustomH2, CustomH3, CustomH4, CustomH5, EyebrowHeading };
